export const encodeURL = (text) => {    
    return text.toLowerCase().replace(" ","_") ;
};
  